import ProductConfig from './data'
const fileType = {
  docType: '8' // 文书图片
}

const docType = {
  check: '1', // 文书审核类型
  draft: '2', // 文书审核类型
}

const payType = {
  aliPay: '0', // 支付宝支付
  wxPay: '1' // 微信H5支付
}

const orderType = {
  tel: 'SC17001',
  doc: 'SC18001'
}

const chargeType = {
  byTime: '2',
  byPer: '1'
}

const productType = {
  timeCard: '3', // 时长卡
  annualCard: '2'// 年卡
}

const couponType = {
  moneyDiscount: '1',
  timeDiscount: '2',
  timesDiscount: '3'
}

const serviceType = {
  tel: 1, // 电话咨询
  card: 2, // 会员卡
  contractDown: 3, // 合同下载
  contractReview: 4, // 合同评审
  doc: 5, //  文书审核，文书起草
  video: 6, // 视频
  contentShare: 7 // 内分享
}

const productCode = {
  minTimeCard: 'PC18003', //  10分钟时长卡
  langTimeCard: 'PC18004', // 15分钟时长卡
  changtCard: 'MC15001', // 畅听卡
  changxCard: 'MC15002', // 畅享卡
  phoneCall: 'SC17001', // 电话咨询
  docCheck: 'SC18001', // 文书审查
  docDraft: 'SC18004', // 文书审查
  docModule: 'SC18002', // 文书模板
  faceConsult: 'SC19001', // 见面咨询
  lawyerLetter: 'SC19002', // 发律师函
  lawsuit: 'SC19003', // 代打官司
  goldCard: 'MC19001', // 金卡
  platinum: 'MC19002', // 白金卡
  taxlaw: 'MC20026', // fs365
  singleCard: 'PC15001', // 次卡,
  goldMonth: 'MC19003', // 金卡月卡
  goldQuarter: 'MC19004', // 金卡季卡
  goldHalf: 'MC19004', // 金卡半年卡
  threeTimesCard: 'PC15001', // 律师咨询次卡（3次
  fscard: 'MC20031', // 律师咨询次卡（3次
  lawcard: 'MC19020', // 律师咨询次卡（3次
}

/**
 * 订单状态
 */
const orderStatus = {
  newSubmit: '1', // 新提交
  isService: '2', // 服务中
  unPay: '3', // 待支付
  evaluated: '4', // 待评价
  finish: '5', // 已完成
  cancel: '99' // 已取消
}

const FIELD_LIST = [
  { value: '4', label: "债权债务"},
  { value: '2', label: "婚姻继承"},
  { value: '3', label: "房产物业"},
  { value: '5', label: "劳动人事"},
  { value: '1', label: '交通出行' },
  { value: '6', label: "消费维权"},
  // { value: '8', label: "合同纠纷"},
  // { value: '24', label:'税务问题' },
  { value: '7', label: "其他"},
  // { value: '9', label: "医疗纠纷"},
  // {label:'知识产权', value: '10'},
  // {label:'企业经营', value: '11'},
  // {label:'定制租售合同', value: '12'},
  // {label:'签发律师函', value: '13'},
  // {label:'拟订法律公告', value: '14'},
  // {label:'工商税务', value: '15'},
  // {label:'刑事辩护', value: '16'},
  // {label:'税务和财富规划', value: '17'},
  // {label:'诉讼仲裁', value: '18'},
  // {label:'股权', value: '19'},
  // {label:'税务筹划', value: '20'},
  // {label:'公司治理', value: '21'},
  // {label:'业务合同', value: '22'},
  // {label:'民商', value: '23'},
]
const FIELD_LIST_MLIST = [
  { value: '4', label: "债权债务"},
  { value: '2', label: "婚姻继承"},
  { value: '3', label: "房产物业"},
  { value: '5', label: "劳动人事"},
  { value: '1', label: '交通出行' },
  { value: '6', label: "消费维权"},
  { value: '8', label: "合同纠纷"},
  { value: '24', label:'税务问题' },
  { value: '7', label: "其他"},
  { value: '9', label: "医疗纠纷"},
  {label:'知识产权', value: '10'},
  {label:'企业经营', value: '11'},
  {label:'定制租售合同', value: '12'},
  {label:'签发律师函', value: '13'},
  {label:'拟订法律公告', value: '14'},
  {label:'工商税务', value: '15'},
  {label:'刑事辩护', value: '16'},
  {label:'税务和财富规划', value: '17'},
  {label:'诉讼仲裁', value: '18'},
  {label:'股权', value: '19'},
  {label:'税务筹划', value: '20'},
  {label:'公司治理', value: '21'},
  {label:'业务合同', value: '22'},
  {label:'民商', value: '23'},
]
const FIELD_LIST_MAP = {
  '1': '交通事故' ,
  '2': "婚姻家庭",
  '3': "房产纠纷",
  '4': "债权债务",
  '5': "劳动纠纷",
  '6': "消费维权",
  '8': "合同纠纷",
  '7': "其他",
  '9': "医疗纠纷",
  '10': "知识产权",
  '11': "企业经营",
  '12': "定制租售合同",
  '13': "签发律师函",
  '14': "拟订法律公告",
  '15': "工商税务",
  '16': "刑事辩护",
  '17': "税务和财富规划",
  '18': "诉讼仲裁",
  '19': "股权",
  '20': "税务筹划",
  '21': "公司治理",
  '22': "业务合同",
  '23': "民商",
  '24': "法税咨询",
}
/**
 * 订单状态
 */
const consultStatus = {
  over: '6' // 通话完成

}

/**
 * 文书订单详情状态
 */
const docOrderType = {
  await: '1',
  checking: '2',
  checked: '3'
}

/**
 * 交互方式
 * @type {{page: number, pop: number}}
 */
const mode = {
  page: 1, // 页面
  pop: 2 // 弹框
}

const bannerType = {
  header: 1,
  body: 2,
  middle: 3
}

const isMember = 1 // 会员

const listStep = function (type) {
  let list
  switch (type) {
    case 'docModule': list = ['成为会员', '选择模板', '导出邮箱', '邮箱验收']; break
    case 'docCheck': list = ['提交订单', '律师报价', '律师审查', '查看结果']; break
    case 'faceConsult':list = ['立即下单', '填写信息', '确认支付', '安排律师', '见面咨询']; break
    case 'lawyerLetter':list = ['立即下单', '填写信息', '确认支付', '安排律师', '发律师函']; break
    case 'lawsuit':
    case 'draftDoc':
      list = ['立即下单', '填写信息', '支付订金', '安排律师', '律师服务']; break
  }
  return list
}

const getOrderStatusName = function (status) {
  console.log('getOrderStatusName status', status)
  let name = ''
  switch (status) {
    case orderStatus.newSubmit: name = '等待服务'; break
    case orderStatus.isService: name = '服务中'; break
    case orderStatus.unPay: name = '待支付'; break
    case orderStatus.finish: name = '已完成'; break
    case orderStatus.cancel: name = '已取消'; break
  }
  return name
}

const getServiceTypeName = function (typeValue) {
  let name = ''
  switch (typeValue) {
    case serviceType.tel: name = '电话咨询'; break
    case serviceType.card: name = '会员卡'; break
    case serviceType.contractDown: name = '合同下载'; break
    case serviceType.contractReview: name = '合同评审'; break
    case serviceType.video: name = '视频咨询'; break
    // case serviceType.Video: name= '视频'
  }
  return name
}

export const data = {
  fileType,
  docType,
  payType,
  productType,
  orderType,
  chargeType,
  isMember,
  mode,
  bannerType,
  orderStatus,
  docOrderType,
  productCode,
  consultStatus,
  serviceType,
  getServiceTypeName,
  getOrderStatusName,
  listStep,
  couponType,
  ProductConfig,
  FIELD_LIST,
  FIELD_LIST_MLIST,
  FIELD_LIST_MAP
}
export default data



// WEBPACK FOOTER //
// ./src/const/index.js